<template>
  <h1 class="Header">&bull;TAVLOR&bull;</h1>
  <div class="Paintings">
    <PaintingCard
      v-for="painting in paintings"
      :key="painting.id"
      v-bind:painting="painting"
    ></PaintingCard>
  </div>
</template>

<script>
import PaintingCard from '@/Components/PaintingCard.vue';

export default {
  setup() {},
  data() {
    return {
      paintings: [
        {
          id: 0,
          imageName: 'tree-tops.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 1,
          imageName: 'beach.jpg',
          title: 'Strandeeeeen!',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 2,
          imageName: 'garden.jpg',
          title: 'Rosor är röda, violer är blå',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 3,
          imageName: 'portrait.jpg',
          title: 'Test!',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 4,
          imageName: 'studio.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 5,
          imageName: 'tomato-field.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 6,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 7,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 8,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 9,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 10,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 11,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
      ],
    };
  },
  components: {
    PaintingCard,
  },
};
</script>

<style>
h1.Header {
  color: black;
  text-shadow: 0px 0px;
}

.Paintings {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
}
</style>
